module.exports = new __parcel__URL__("stormcloud.0dab84a7.png").toString();